import { observable, action } from 'mobx'
import ApiCaller from '../utils/api-caller'
import localStorage from '../utils/localStorage';

class ChatStore {
    @observable chatList = []
    @observable message = ''
    @observable unreadChatCount = 0
    @observable loading = false
    @observable isKeepLoading = false
    @observable currentImage = ""
    @observable isViewerOpen = false

    @action
    setCurrentImage(currentImage) {
        this.currentImage = currentImage
    }

    @action
    setIsViewerOpen(isViewerOpen) {
        this.isViewerOpen = isViewerOpen
    }

    @action
    setMessage(message) {
        this.message = message
    }

    @action
    setKeepLoading(keepLoading) {
        this.isKeepLoading = keepLoading;
    }

    @action async auth() {
        this.loading = true;
        const username = `StayMenu_${localStorage.Get('customerId')}`;
        const password = localStorage.Get('roomNo');

        await ApiCaller.Chat.Auth(username, password)
            .finally(() => {
                console.log("Login to StayChat WebSocket succeed");
                this.loading = false;
            });
    }

    @action load() {
        this.loading = true;
        const nodeName = localStorage.Get('roomNo')
        const customerId = localStorage.Get('customerId')

        return ApiCaller.Chat.Load(nodeName, customerId)
            .then((response) => {
                localStorage.Save('currentChatCount', response.length);
                this.chatList = response
                return response
            })
            .finally(() => {
                // TODO: Since when chatbot off it keeps loading we set this as false for now
                // if (!this.isKeepLoading) this.loading = false;
                this.loading = false;
            });
    }

    @action reload() {
        this.loading = true;
        const nodeName = localStorage.Get('roomNo')
        const customerId = localStorage.Get('customerId')

        return ApiCaller.Chat.Load(nodeName, customerId)
            .then((response) => {
                if (response.length !== localStorage.Get('currentChatCount')) {
                    localStorage.Save('currentChatCount', response.length);
                    this.chatList = response
                }
            })
            .finally(() => {
                if (!this.isKeepLoading) this.loading = false;
            });
    }

    @action sync() {
        this.loading = true;
        const nodeName = localStorage.Get('roomNo')
        const customerId = localStorage.Get('customerId')

        return ApiCaller.Chat.Load(nodeName, customerId)
            .then((response) => {
                localStorage.Save('latestChatCount', response.length);
                this.unreadChatCount = localStorage.Get('latestChatCount') - localStorage.Get('currentChatCount')
            })
            .finally(() => {
                this.loading = false;
            });
    }

    @action
    send() {
        this.loading = true;

        const localMessage = this.message;
        this.message = '';

        const nodeName = localStorage.Get('roomNo')
        const customerId = localStorage.Get('customerId')
        const lastName = localStorage.Get('lastName');

        return ApiCaller.Chat.Send(nodeName, customerId, localMessage, lastName)
            .then((response) => {
                return response;
            })
            .finally(() => {
                // this.loading = false;
            });
    }

    @action
    sendVoice(file) {
        this.loading = true;

        const nodeName = localStorage.Get('roomNo')
        const customerId = localStorage.Get('customerId')
        const lastName = localStorage.Get('lastName');

        return ApiCaller.Chat.SendVoice(file, nodeName, customerId, lastName)
            .then((response) => {
                return response
            })
            .finally(() => {
                // this.loading = false;
            });
    }

    @action
    sendFile(file) {
        this.loading = true;
        const nodeName = localStorage.Get('roomNo')
        const customerId = localStorage.Get('customerId')
        const lastName = localStorage.Get('lastName');

        return ApiCaller.Chat.SendFile(file, nodeName, customerId.toString(), lastName)
            .then((response) => {
                return response
            })
            .finally(() => {
                this.loading = false;
            });
    }

    @action
    read() {
        this.loading = true;
        const customerId = localStorage.Get('customerId');

        return ApiCaller.Chat.Read(customerId)
            .finally(() => {
                this.loading = false;
            });
    }
}

export default new ChatStore();
